import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading, isAdmin, unreachable, refreshMe } = useAuth();
  if (loading) {
    return (
      <div data-testid="auth-loading"
           className="min-h-screen flex flex-col items-center justify-center gap-3 text-slate-400 px-6 text-center">
        {unreachable ? (
          <>
            <p data-testid="auth-unreachable" className="text-slate-600">
              Kan inte nå servern just nu. Du är fortfarande inloggad – vi försöker igen automatiskt.
            </p>
            <button type="button" data-testid="auth-retry-btn" onClick={refreshMe}
                    className="press-feedback text-sm font-semibold text-[#3B9EDA]">
              Försök igen
            </button>
          </>
        ) : "Laddar…"}
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && !isAdmin) return <Navigate to="/" replace />;
  return children;
}

export default ProtectedRoute;
